import { useMemo } from 'react';
import { BreadcrumbComponentType } from 'use-react-router-breadcrumbs';

import { useBreadcrumbDomainsQuery } from '../../Domains';
import { DynamicBreadcrumbWrapper } from './DynamicBreadcrumbWrapper';
import { DomainPunycode } from '../../../common/components';

const DynamicDomainsByIdBreadcrumb: BreadcrumbComponentType<'domainId'> = ({ match }) => {
  const domainId = useMemo(() => match.params.domainId ?? '', [match.params.domainId]);

  const breadcrumbQuery = useBreadcrumbDomainsQuery(domainId)();

  return (
    <DynamicBreadcrumbWrapper
      { ...breadcrumbQuery }
      data={ DomainPunycode.stringFormat(breadcrumbQuery.data ?? '') }
    />
  );
};

const DynamicDomainsListBreadcrumb: BreadcrumbComponentType = () => {
  return <span>Домени</span>;
};

const DynamicDomainsConfigBreadcrumb: BreadcrumbComponentType = () => {
  return <span>Розгортання</span>;
};

const DynamicDomainsRegluingBreadcrumb: BreadcrumbComponentType = () => {
  return <span>Переклейка</span>;
};

export const DynamicDomainsBreadcrumb = {
  DynamicDomainsByIdBreadcrumb,
  DynamicDomainsListBreadcrumb,
  DynamicDomainsConfigBreadcrumb,
  DynamicDomainsRegluingBreadcrumb
};
